/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_SubtitleInputs */

const en_settings_plan_subtitle = /** @type {(inputs: Settings_Plan_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan and payment`)
};

const es_settings_plan_subtitle = /** @type {(inputs: Settings_Plan_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan y pago`)
};

/**
* | output |
* | --- |
* | "Your plan and payment" |
*
* @param {Settings_Plan_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_plan_subtitle = /** @type {((inputs?: Settings_Plan_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_plan_subtitle(inputs)
	return en_settings_plan_subtitle(inputs)
});